import {
  BASEMAP_ESRI_NAVIGATION_DARK,
  BASEMAP_ESRI_NAVIGATION_LIGHT,
  BASEMAP_ESRI_SATELLITE,
  BASEMAP_GOOGLE_HYBRID,
  BASEMAP_GOOGLE_ROADMAP,
} from '@rsos/constants/basemapAddonNames';
import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';
import { ESRI, GOOGLE } from '@rsos/maps/constants/mapProviders';

const LEGACY_CATEGORY = 'Data Map';

const BASEMAP_EVENT_NAMES = {
  BASEMAP_CLICK: 'map_basemap_click',
  ADDON_CLICK: 'map_basemap_addon_click',
};

/**
 * Tracks basemap clicks in the basemap menu.
 * @param {Number} irpVersion - irpVersion in RapidSOS Portal.
 * @param {String} mapProvider - The map provider rendered in RapidSOS Portal.
 * @param {String} basemap - The basemap used on the map.
 * @param {Boolean} isBasemapVisible - Is the basemap visible on the map.
 */
export const trackBasemapClick = ({
  irpVersion,
  mapProvider,
  basemap,
  isBasemapVisible,
}) => {
  let trackingName = '';

  const isSatelliteBasemap =
    basemap === BASEMAP_ESRI_SATELLITE || basemap === BASEMAP_GOOGLE_HYBRID;

  const isNavigationBasemap =
    basemap === BASEMAP_ESRI_NAVIGATION_DARK ||
    basemap === BASEMAP_ESRI_NAVIGATION_LIGHT ||
    basemap === BASEMAP_GOOGLE_ROADMAP;

  if (mapProvider === ESRI) {
    if (!isBasemapVisible) {
      trackingName = 'None: Switch to None Basemap';
    } else if (isNavigationBasemap) {
      trackingName = 'Esri Map: Switch to Esri Navigation Basemap';
    } else if (isSatelliteBasemap) {
      trackingName = 'Esri Satellite: Switch to Esri Satellite Basemap';
    }
  } else if (mapProvider === GOOGLE) {
    if (isSatelliteBasemap) {
      trackingName = 'Google Satellite: Switch to Google Satellite Basemap';
    } else if (isNavigationBasemap) {
      trackingName = 'Google Map: Switch to Google Navigation Basemap';
    }
  }

  gspx.trackEvent({
    name: BASEMAP_EVENT_NAMES.BASEMAP_CLICK,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: trackingName,
      Category: 'Basemap',
      irpVersion,
      'Launched date': new Date(),
      mapProvider,
      basemap,
      isBasemapVisible,
    },
  });
};

/**
 * Tracks addon clicks in the basemap menu.
 * @param {Number} irpVersion - irpVersion in RapidSOS Portal.
 * @param {Boolean} isEnabled - Is the GIS addon enabled?
 */
export const trackAddonClick = ({ irpVersion, isEnabled }) => {
  let trackingName = '';

  if (isEnabled) {
    trackingName = 'GIS ON: Toggle GIS Layer On';
  } else {
    trackingName = 'GIS OFF: Toggle GIS Layer Off';
  }

  gspx.trackEvent({
    name: BASEMAP_EVENT_NAMES.ADDON_CLICK,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.MAP,
    additionalKeys: {
      legacy_category: LEGACY_CATEGORY,
      legacy_name: trackingName,
      Category: 'Basemap',
      irpVersion,
      'Launched date': new Date(),
      isEnabled,
    },
  });
};
